/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import {
	animate,
	state,
	style,
	transition,
	trigger,
} from "@angular/animations";

export const BACKDROP_ANIMATIONS = [
	trigger("backdropAnimation", [
		state("opened", style({ opacity: 1, backdropFilter: "blur(5px)" })),
		state("closed", style({ opacity: 0, backdropFilter: "blur(0px)" })),
		transition("opened => closed", [
			animate(
				"80ms ease-out",
				style({ opacity: 0, backdropFilter: "blur(0px)" }),
			),
		]),
		transition("closed => opened", [
			style({ opacity: 0, backdropFilter: "blur(0px)" }),
			animate(
				"80ms ease-in",
				style({ opacity: 1, backdropFilter: "blur(5px)" }),
			),
		]),
	]),
];
export const DIALOG_ANIMATIONS = [
	trigger("dialogAnimation", [
		state("void", style({ opacity: 0 })),
		state("closed", style({ opacity: 0 })),
		state("center", style({ opacity: 1 })), // Centered by default
		state("top", style({ opacity: 1, top: "0" })),
		state("bottom", style({ opacity: 1, bottom: "0" })),
		state("left", style({ opacity: 1, left: "0" })),
		state("right", style({ opacity: 1, right: "0" })),

		// Centered dialog
		transition("void => center", [
			style({
				opacity: 0,
				top: "50%",
				left: "50%",
				transform: "scale(0.8)",
			}),
			animate("120ms ease-in", style({ opacity: 1, transform: "scale(1)" })),
		]),
		transition("center => closed", [
			animate("120ms ease-out", style({ opacity: 0, transform: "scale(0.8)" })),
		]),

		// Top dialog
		transition("void => top", [
			style({ opacity: 0, transform: "translateY(-100px) scale(1)" }),
			animate(
				"160ms ease-in",
				style({ opacity: 1, transform: "translateY(0) scale(1)" }),
			),
		]),
		transition("top => closed", [
			animate(
				"160ms ease-out",
				style({ opacity: 0, transform: "translateY(-100px) scale(1)" }),
			),
		]),

		// Bottom dialog
		transition("void => bottom", [
			style({ opacity: 0, transform: "translateY(100px) scale(1)" }),
			animate(
				"160ms ease-in",
				style({ opacity: 1, transform: "translateY(0) scale(1)" }),
			),
		]),
		transition("bottom => closed", [
			animate(
				"160ms ease-out",
				style({ opacity: 0, transform: "translateY(100px) scale(1)" }),
			),
		]),

		// Left dialog
		transition("void => left", [
			style({ opacity: 0, transform: "translateX(-100px) scale(1)" }),
			animate(
				"160ms ease-in",
				style({ opacity: 1, transform: "translateX(0) scale(1)" }),
			),
		]),
		transition("left => closed", [
			animate(
				"160ms ease-out",
				style({ opacity: 0, transform: "translateX(-100px) scale(1)" }),
			),
		]),

		// Right dialog
		transition("void => right", [
			style({ opacity: 0, transform: "translateX(100px) scale(1)" }),
			animate(
				"160ms ease-in",
				style({ opacity: 1, transform: "translateX(0) scale(1)" }),
			),
		]),
		transition("right => closed", [
			animate(
				"160ms ease-out",
				style({ opacity: 0, transform: "translateX(100px) scale(1)" }),
			),
		]),
	]),
];
